import { measuredUsingConfigFor as wrap } from '../../../Components/Worksheets/Core/Helpers/configHelpers';

const getMeasuredUsingConfig = (prefix: string) => {
  const balance = wrap(`${prefix}.Preparation.Balance`);
  return {
    [`${prefix}.Preparation.MassOfSandInCone`]: balance,
    [`${prefix}.Measurement.MassOfExcavatedWetSoil`]: balance,
    [`${prefix}.Measurement.MassOfSandAfterPouring`]: balance,
  };
};

export default getMeasuredUsingConfig;
